import * as RadixTabs from '@radix-ui/react-tabs';
import { Tab } from './Tabs.types';

interface TabsContentProps {
  tabs: Tab[];
}

const TabsContent = ({ tabs }: TabsContentProps) => {
  return (
    <>
      {tabs.map(
        ({ content, id }) =>
          content && (
            <RadixTabs.Content key={id} value={id} className="display-scrollbar-lg h-full w-full overflow-y-auto">
              {content}
            </RadixTabs.Content>
          )
      )}
    </>
  );
};

export default TabsContent;
